import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const OCOYA_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.ocoya.buyBox.bulletPoint1' },
        { title: 'productPage.ocoya.buyBox.bulletPoint2' },
        { title: 'productPage.ocoya.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.ocoya.buyBox.productName',
      interactService: {
        service: 'ocoya',
        openInNewTab: true
      },
      ctaIcon: {
        src: '/s2/material-icons/openinnewrounded.svg',
        alt: ''
      }
    }],
    headerPicture: {
      src: '/s2/raster/livestream-desk-boxes.png',
      alt: 'productPage.ocoya.heroPicture.altText'
    },
    headline: 'productPage.ocoya.page.headline',
    partnerLogo: {
      src: '/s2/vector/partnership-ocoya.svg',
      alt: ''
    },
    partnerReviewBlanks: [],
    subheader: 'productPage.ocoya.page.subheader'
  },
  benefit: {
    title: 'productPage.ocoya.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/addcircleoutlinerounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle1',
        description: 'productPage.ocoya.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/formatcolortextrounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle2',
        description: 'productPage.ocoya.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/eventnoterounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle3',
        description: 'productPage.ocoya.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/linkrounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle4',
        description: 'productPage.ocoya.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/localmallrounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle5',
        description: 'productPage.ocoya.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/groupsrounded.svg',
        title: 'productPage.ocoya.valueProp.propTitle6',
        description: 'productPage.ocoya.valueProp.shortCopy6'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/boltrounded.svg',
    title: 'productPage.ocoya.topFeature.title',
    subheader: 'productPage.ocoya.topFeature.subheader',
    image: '/s2/raster/ring-light-clothing-smile.png',
    alt: ''
  },
  assistance: {
    title: 'productPage.ocoya.needAssistance.title',
    getInTouch: 'productPage.ocoya.needAssistance.getInTouch',
    actions: 'productPage.ocoya.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.ocoya.buyBox.buttonLabel'
  })
};
